// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__16AAs","inputWrap":"styles_inputWrap__1MSXh","input":"styles_input__1j7jq"};